import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import classnames from 'classnames';

const TutoriumInput = ({ field, form, label, type, placeholder, disabled, isMobile }) => {
  const hasError = form.errors[field.name] && form.touched[field.name];

  const labelClassName = classnames('label profile-label', { 'is-invalid': hasError });
  const fieldClassName = classnames('profile-input', { 'profile-input-sm': isMobile, 'is-invalid': hasError });

  return (
    <div className="field">
      {label && <label className={labelClassName}>{label}</label>}
      <div className="control">
        <Field
          type={type || 'text'}
          {...field}
          className={fieldClassName}
          placeholder={placeholder || ''}
          disabled={disabled || false}
        />
      </div>
      {hasError && <p className="profile-input-message is-invalid">{form.errors[field.name]}</p>}
    </div>
  );
};

TutoriumInput.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default TutoriumInput;
